<template>
  <div
    v-if="btnImg"
    :style="{
      width: width,
      height: height,
      fontSize: fontSize,
      fontColor: color,
      backgroundImage: 'url(' + btnImg + ')'
    }"
    class="setup-button"
    @click="setup"
  >
    {{ buttonText }}
  </div>
</template>
<script>
import { getUrlQuery } from '@/common/utils';
import { api } from '@/common/api';
import { env } from '@/common/env';
import { getMobileSystem } from '@/tools/format';
import { monitor } from '@/common/monitor';
import { dcepAppConfig } from '../config/dcepApp';
import ResponseUtil from '@/tools/decryptUtil';
import ToastUtil from '@/tools/ToastUtil';

export default {
  props: {
    buttonText: {
      type: String,
      default: '下载App'
    },
    isFinished: {
      type: Boolean,
      default: false
    },
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
    btnImg: {
      type: String,
      default:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/btn-active-20220407.png'
    },
    width: {
      type: String,
      default: '1.94rem'
    },
    height: {
      type: String,
      default: '0.54rem'
    },
    fontSize: {
      type: String,
      default: '0.22rem'
    },
    color: {
      type: String,
      default: '#4c1111'
    },
    bankType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneType: ''
    };
  },
  methods: {
    setup() {
      this.$emit('download');
      if (this.isFinished) {
        return;
      }
      if (this.hasOpenThatBank) {
        // 推子流程
        this.pushSubWalletStrategy();
      } else {
        // 开通流程
        this.jumpToDcepApp();
      }
    },
    downloadApp() {
      const url =
        this.phoneType === 'iphone'
          ? dcepAppConfig.downloadUrl.iosUrl
          : dcepAppConfig.downloadUrl.androidUrl;
      const errorMsg = this.phoneType === 'iphone' ? 'App Store' : '应用商店';
      this.$bridge.openWebview(url, () => {
        ToastUtil.show(`打开/下载数币App失败，可自行到${errorMsg}下载`);
        monitor.captureMessage(
          {
            name: '下载数币App失败',
            msg: JSON.stringify(url)
          },
          {
            level: 'error'
          }
        );
      });
    },
    pushSubWalletStrategy() {
      if (this.pushSubWalletABStrategy === 'standard' || this.pushSubWalletABStrategy === 'popWindow') {
        // 一键推子
        this.pushSubWallet();
      } else {
        // 原版本
        this.jumpToDcepApp();
      }
    },
    jumpToDcepApp() {
      let url = '';
      if (this.phoneType === 'iphone') {
        url = dcepAppConfig.appId.scheme;
      } else {
        url = dcepAppConfig.jumpToAppAndriodScheme;
      }
      this.$bridge.openPage(url, () => {
        // 打开数币App失败，降级跳转到下载页面
        this.downloadApp();
        monitor.captureMessage(
          {
            name: '打开数币App失败',
            msg: JSON.stringify(url)
          },
          {
            level: 'info'
          }
        );
      });
    },
    async pushSubWallet() {
      try {
        const originUrl = window.location.href;
        const paramsObj = env.businessParams || {};
        const paramsList = Object.keys(paramsObj);
        let paramsUrl = `openFromEcny=true`;
        // 添加业务参数
        paramsList.forEach(item => {
          if (paramsObj[item]) {
            paramsUrl = `${paramsUrl}&${item}=${paramsObj[item]}`;
          }
        });
        let callbackUrl;
        if (originUrl.indexOf('#') !== -1) {
          const urlList = originUrl.split('#/') || [];
          const urlNoParam = urlList[0].split('?')[0];
          // #/后没有路由的去掉#
          callbackUrl = urlList[1]
            ? `${urlNoParam}?${paramsUrl}#/${urlList[1]}`
            : `${urlNoParam}?${paramsUrl}`;
        } else {
          callbackUrl =
            originUrl.indexOf('?') === -1
              ? `${originUrl}?${paramsUrl}`
              : `${originUrl.split('?')[0]}?${paramsUrl}`;
        }
        const mtScheme = 'imeituan://web';
        const encodeCallbackUrl = encodeURIComponent(callbackUrl);
        const returnUrl = `${mtScheme}?url=${encodeCallbackUrl}&needSpliceParams=true`;
        const res = await this.queryReverseBindWalletInfo(returnUrl);
        if (!res) {
          // 接口异常，抛出error
          throw new Error(`res为空:${res}`)
        };
        const {
          sign,
          app_id,
          inst_no,
          extra_info,
          sign_info,
          biz_type,
          mobile
        } = res;
        const mblPhNo = ResponseUtil.decrypt(mobile);
        const url = `${dcepAppConfig.bindWalletScheme}?appId=${encodeURIComponent(
          app_id
        )}&extraInfo=${encodeURIComponent(extra_info)}&biz=${encodeURIComponent(
          biz_type
        )}&instNo=${encodeURIComponent(inst_no)}&signInfo=${encodeURIComponent(
          sign_info
        )}&sign=${encodeURIComponent(sign)}&mblPhNo=${encodeURIComponent(
          mblPhNo
        )}`;
        this.$bridge.openPage(url, () => {
          monitor.captureMessage(
            {
              name: '【一键推子】打开数币App失败',
              msg: JSON.stringify(url)
            },
            {
              level: 'error'
            }
          );
          // 打开数币App失败，降级跳转到下载页面
          this.downloadApp();
        });
      } catch (err) {
        monitor.captureMessage(
          {
            name: '一键推子失败',
            msg: JSON.stringify(err)
          },
          {
            level: 'error'
          }
        );
        // 尝试降级打开数币App
        this.jumpToDcepApp()
      }
    },
    async queryReverseBindWalletInfo(returnUrl) {
      try {
        const res = await api.queryReverseBindWalletInfo({
          return_url: returnUrl,
          payType: this.bankType
        });
        return res;
      } catch (err) {
        console.log(err);
        return '';
      }
    }
  },
  mounted() {
    this.phoneType = getMobileSystem() || 'android';
  }
};
</script>
<style scoped lang="less">
.setup-button {
  background-image: linear-gradient(180deg, #ffe25c 0%, #ffd100 100%);
  background-size: 100% auto;
  background-repeat: no-repeat;
  font-family: PingFangSC-Semibold;
  letter-spacing: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
</style>
